import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { Status } from 'common/utils/constants';
import { logger } from 'common/utils/helpers';
import { requestLogin, handleAuthentication } from 'redux/actions';
import { createStatusSelector } from 'redux/selectors';
import { useAuth } from 'components/shared/Auth';
import ConsolePage from 'pages/ConsolePage/ConsolePage';
import HeatmapPage from 'pages/HeatmapPage/HeatmapPage';
import LogoutPage from 'pages/LogoutPage';
import LoginPage from 'pages/LoginPage';
import ErrorPage from 'pages/ErrorPage';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleUp,
  faAngleLeft,
  faAngleDoubleDown,
  faAngleRight,
  faBolt,
  faCheck,
  faCheckCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faClock,
  faCog,
  faColumns,
  faDesktop,
  faEllipsisV,
  faFile,
  faGripLinesVertical,
  faList,
  faMap,
  faSignInAlt,
  faSignOutAlt,
  faSpinner,
  faSuitcase,
  faSearch,
  faUndoAlt,
  faUserCircle,
  faWifi,
  faTimes
} from '@fortawesome/free-solid-svg-icons';

/**
 * Create the icon library from Font Awesome (free packages)
 */
library.add(
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faAngleDoubleDown,
  faBolt,
  faCheck,
  faCheckCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faClock,
  faCog,
  faColumns,
  faDesktop,
  faEllipsisV,
  faFile,
  faGripLinesVertical,
  faList,
  faMap,
  faSignInAlt,
  faSignOutAlt,
  faSpinner,
  faSuitcase,
  faSearch,
  faUndoAlt,
  faUserCircle,
  faWifi,
  faTimes
);

function Callback() {
  const dispatch = useDispatch();
  const selectAuth0Status = useMemo(() => createStatusSelector('auth0'), []);
  const auth0status = useSelector(selectAuth0Status);

  useEffect(() => {
    if (auth0status === Status.NONE) {
      dispatch(requestLogin());
    }

    if (auth0status === Status.PENDING) {
      dispatch(handleAuthentication());
    }
  }, [dispatch, auth0status]);

  switch (auth0status) {
    case Status.NONE:
    case Status.PENDING:
      return null;
    case Status.SUCCESS:
      return <Redirect to={getRedirectUrl()} />;
    case Status.FAILURE:
    default:
      return <Redirect to="/error/authentication-failed" />;
  }
}

function getRedirectUrl() {
  let url = localStorage.getItem('redirectUrl');
  logger.info('redirectUrl:', url);
  if (url == null) {
    url = '/console/devices';
  }

  return url;
}

function App() {
  const auth = useAuth();

  return (
    <div>
      <Route exact path="/" render={() => <Redirect to="/auth0" />} />
      <Route
        exact
        path="/auth0"
        render={() => (auth.isAuthenticatedLS() ? <Redirect to="/console/devices" /> : <Redirect to="/login" />)}
      />
      <Route path="/login" render={() => <LoginPage />} />
      <Route exact path="/logout" render={() => <LogoutPage />} />
      <Route path="/console" render={() => <ConsolePage />} />
      <Route path="/heatmap/:id" render={() => <HeatmapPage />} />
      <Route exact path="/Callback" render={() => <Callback />} />
      <Route path="/error" render={() => <ErrorPage />} />
    </div>
  );
}

export default App;
